import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';

export const Root = styled(Box)({
    '& .head': {
        marginBottom: '17px',
    },
    '& .subtitle': {
        color: '#9B9B9B',
        fontSize: '12px',
    },
    '& .title': {
        color: '#005E96',
        fontSize: '16px',
    },
    '& .crtTitle': {
        color: '#005E96',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    '& .bgW': {
        width: '100%',
        backgroundColor: '#fff',
    },
    '& .tableTool': {
        padding: '16px',
        backgroundColor: '#FAFAFA',
        borderBottom: '1px solid #D8D8D8',
        '& .searchWapper': {
            border: '1px solid #CCCCCC',
            borderRadius: '3px',
            width: '285px',
            height: '38px',
            '& .search': {
                height: '32px',
                color: '#58727C',
                padding: '0 10px',
                backgroundColor: '#fff',
            },
        },
        '& .btn': {
            border: '1px solid #CCCCCC',
        },
    },
    '& .tableWapper': {
        width: '100%',
        backgroundColor: '#fff',
    },
    '& .itemWapper': {
        width: '135px',
        height: '139px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        margin: '0 20px',
        boxShadow: '1px 1px 7px 2px rgba(0,0,0,0.12)',
        borderRadius: '13px',
    },
    '& .itemWapper:nth-child(1)': {
        textAlign: 'center'
    },
    '& .itemWapper:hover': {
        cursor: 'pointer',
        margin: '0 20px',
        backgroundColor: '#009CEE',
        color: '#fff',
    },
    '& .basic-status': {
        width: '110px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: 'gray'
    },
    '& .color-final': {
        backgroundColor: '#18C6FF'
    },
    '& .color-draft': {
        backgroundColor: '#43D79E'
    },
    '& .color-email': {
        backgroundColor: '#F7B500'
    },
    '& .color-manual': {
        backgroundColor: '#FA6400'
    },
    '& .del': {
        color: '#9B9B9B',
        cursor: 'pointer',
    },
    '& .loadingWapper': {
        width: '800px',
        padding: '40px',
        '& .loadingTitle': {
            marginBottom: '40px',
            color: '#0060A0',
            fontWeight: 'bold',
        },
    },
});